export default {"src":"/_next/static/media/travel_agents.aaf31168.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};